import { render, staticRenderFns } from "./OverviewValue.vue?vue&type=template&id=2d69f22d"
import script from "./OverviewValue.vue?vue&type=script&lang=js"
export * from "./OverviewValue.vue?vue&type=script&lang=js"
import style0 from "./OverviewValue.vue?vue&type=style&index=0&id=2d69f22d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports